import {Injectable} from '@angular/core';
import {ParamNdf} from '@domain/admin/parametre/formulaire/param-ndf';
import {FormulaireHttpService} from '@services/admin/parametre/formulaire/formulaire-http.service';
import {finalize} from 'rxjs/operators';
import {handleResult} from "@share/utils/handle-result";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {Result} from "@domain/common/http/result";
import {MessageNotification} from "@domain/admin/parametre/formulaire/message-notification";

/**
 * Service de gestion des paramètres NDF
 *
 * @author Lionel Gimenez
 * @date 11/09/2025
 */
@Injectable()
export class FormulaireNdfService {
    /** Paramètres NDF */
    paramNdf: ParamNdf;

    /** Liste des notifications */
    messageNotificationListe: MessageNotification[];

    /** Indicateur de sauvegarde en cours */
    isSaving: boolean = false;

    /**
     * Constructeur
     */
    constructor(
        private formulaireHttpService: FormulaireHttpService,
        private translateService: TranslateService,
        private toastrService: ToastrService
    ) {
    }

    /**
     * Charge les paramètres NDF
     */
    load(): void {
        this.isSaving = true;
        this.formulaireHttpService.getParamNdf()
            .pipe(
                handleResult(this.translateService, this.toastrService,null, 'global.errors.generic'),
                finalize(() => this.isSaving = false)
            )
            .subscribe(
                (result: Result) => {
                    this.paramNdf = result.data.param;
                    this.messageNotificationListe = result.data.listeNotification;

                    //On crée une ligne custom pour aucun dans les notifications
                    const notification: MessageNotification = {
                        idMessage: 0,
                        titre: this.translateService.instant("admin.parametres.formulaire.om.mailOption.aucun")
                    }
                    this.messageNotificationListe.push(notification);
                }
            );
    }

    /**
     * Sauvegarde les paramètres NDF
     */
    save(): void {
        this.isSaving = true;
        this.formulaireHttpService.saveParamNdf(this.paramNdf)
            .pipe(
                handleResult(this.translateService, this.toastrService),
                finalize(() => this.isSaving = false)
            )
            .subscribe(() => {
                //Refresh
                this.load();
            });
    }
}
